import { orderLegSideEnum } from '@/constants/order'
import { calculateGcd } from './calculateGcd'
import { CallPut } from '@/enums/OrderTicket.enum'

export function calculateBidAsk(legs) {
  let totals = {
    longBid: 0,
    shortAsk: 0,
    longAsk: 0,
    shortBid: 0,
    longLast: 0,
    shortLast: 0,
  }

  const legQuantities = []

  // for single leg, use the simple scenario because multileg complexity not needed
  if (legs?.length === 1) {
    const bid = parseFloat(legs[0].bid)
    const ask = parseFloat(legs[0].ask)
    const last = parseFloat(legs[0].lastPrice || 0)
    const mid = (ask + bid) / 2
    return {
      spreadBid: bid.toFixed(2),
      spreadAsk: ask.toFixed(2),
      spreadLast: last.toFixed(2),
      spreadMid: mid.toFixed(2),
    }
  }

  legs.forEach(
    ({
      side,
      legType,
      type,
      quantity = 1,
      bid = 0,
      ask = 0,
      lastPrice = 0,
    }) => {
      const actualType = type || legType
      const bidValue = parseFloat(bid)
      const askValue = parseFloat(ask)
      const lastValue = parseFloat(lastPrice)

      let absQty = Math.abs(quantity)

      if (actualType === CallPut.equity || actualType === 'STOCK')
        absQty = absQty / 100

      if (absQty < 1) {
        absQty = 1
      }

      legQuantities.push(absQty)

      if (side === orderLegSideEnum.BUY) {
        totals.longBid += bidValue * absQty
        totals.longAsk += askValue * absQty
        totals.longLast += lastValue * absQty
      } else if (side === orderLegSideEnum.SELL) {
        totals.shortAsk += askValue * absQty
        totals.shortBid += bidValue * absQty
        totals.shortLast += lastValue * absQty
      }
    }
  )

  let gcd = calculateGcd(legQuantities)
  if (!gcd) gcd = 1

  let ask = (totals.longAsk - totals.shortBid) / gcd
  let bid = (totals.longBid - totals.shortAsk) / gcd
  const last = Math.abs((totals.longLast - totals.shortLast) / gcd)
  const mid = Math.abs((ask + bid) / 2)

  if (ask < 0 && bid < 0) {
    ask = Math.abs(ask)
    bid = Math.abs(bid)
  }

  return {
    spreadBid: Math.min(ask, bid).toFixed(2),
    spreadAsk: Math.max(ask, bid).toFixed(2),
    spreadLast: last.toFixed(2),
    spreadMid: mid.toFixed(2),
  }
}
